var _circle, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStep2Icon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 141,
    viewBox: "0 0 45 141",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 22.5,
    fill: "url(#paint0_linear_2228_1264)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.54 32H13.69V29.12C13.69 25.58 15.22 23.75 19.45 22.34L24.61 20.66C26.41 20.03 27.07 19.43 27.07 18.11C27.07 16.58 26.23 15.71 22.93 15.71C19.24 15.71 18.13 16.82 18.13 19.04V19.43H13.72V19.04C13.72 15.14 16.39 11.6 23.08 11.6C29.14 11.6 31.6 14.36 31.6 18.17C31.6 21.74 29.26 23.51 25.69 24.5L21.31 25.7C19.36 26.3 18.43 26.87 18.43 28.46L23.68 27.95H31.54V32Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 55L22 140",
    stroke: "url(#paint1_linear_2228_1264)",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2228_1264",
    x1: 0,
    y1: 22.5,
    x2: 45,
    y2: 22.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2069FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003CB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2228_1264",
    x1: 20.5,
    y1: 55,
    x2: 20.5,
    y2: 140,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2069FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003CB7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep2Icon);
export default __webpack_public_path__ + "static/media/step2Icon.9e2bf848e02494822b2c00cb2c433a0d.svg";
export { ForwardRef as ReactComponent };